import { useParams } from 'react-router-dom';

import useFeatureFlags from 'api/useFeatureFlags';
import { EFeatureFlag } from 'constants/enums';

export const useDeveloperSettingsEnabled = (): boolean => {
  const { publisherId } = useParams();
  const { featureFlags } = useFeatureFlags({ publisherId });
  return !!featureFlags?.[EFeatureFlag.DASHBOARD_DISPLAY_DEVELOPER_SETTINGS_PAGE];
};

